import { h } from '@stencil/core';
export class PesRichTextInformation {
  constructor() {
    this.richText = undefined;
  }
  render() {
    var _a;
    return (((_a = this.richText) === null || _a === void 0 ? void 0 : _a.length) > 0 && (h("div", { class: "product-information" }, this.richText.map((text) => (h("p", { class: "text", innerHTML: text }))))));
  }
  static get is() { return "pes-rich-text-information"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["rich-text-information.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["rich-text-information.css"]
    };
  }
  static get properties() {
    return {
      "richText": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "string[]",
          "resolved": "string[]",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
}
